"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _constanst = require("../../../utils/constanst");

var _utils = _interopRequireDefault(require("../../../utils/utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var styles = {
  container: {
    diaplay: "flex",
    flex: 1,
    position: "relative"
  },
  field: {
    marginTop: "5px"
  }
};

var Text = function Text(props) {
  var _useState = (0, _react.useState)(""),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = (0, _react.useState)(""),
      _useState4 = _slicedToArray(_useState3, 2),
      errorText = _useState4[0],
      setErrorText = _useState4[1];

  var isValid = function isValid(field, value) {
    var validation = new RegExp(field.customValidation, "i");
    var result = validation.test(value) && !_utils.default.isOnlywhiteSpaceOrEmpty(value);
    return result;
  };

  (0, _react.useEffect)(function () {
    if (props.field.hasError) {
      setErrorText(_constanst.MSG_REQUIRED);
    }
  }, [props.field.hasError]);
  (0, _react.useEffect)(function () {
    setValue(props.defaultValue);
  }, [props.defaultValue]);

  var handleChange = function handleChange(e) {
    var value = e.target.value.trimStart();
    props.handleChange(props.fieldId, value);
    setValue(value);
    var msg = "";

    if (!props.field.allowNull && _utils.default.isOnlywhiteSpaceOrEmpty(e.target.value)) {
      msg = props.field.customRequiredMessage ? props.field.customRequiredMessage : _constanst.MSG_REQUIRED;
    } else if (props.field.customValidation) {
      if (!isValid(props.field, e.target.value)) {
        var _msg = props.field.customValidationMessage ? props.field.customValidationMessage : _constanst.MSG_REQUIRED;

        setErrorText(_msg);
      }
    }

    setErrorText(msg);
  };

  var defaultStyles = styles.field || {};
  var style = !props.field.isActiveCustomStyles ? defaultStyles : _utils.default.stringToObject(props.field.customStyles);
  var textFieldContainerStyle = {
    visibility: props.disable ? "hidden" : "visible"
  };
  var styleOverflowText = {
    width: "-webkit-fill-available",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
  };

  var mergeStyles = _objectSpread(_objectSpread({}, style), styleOverflowText);

  return /*#__PURE__*/React.createElement("div", {
    style: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    style: textFieldContainerStyle
  }, /*#__PURE__*/React.createElement(_TextField.default, {
    label: props.label,
    onChange: handleChange,
    type: props.type.name || props.type,
    style: mergeStyles,
    value: value,
    disabled: props.readOnly || props.field.isReadOnly,
    name: props.field.name || "",
    id: props.fieldId || "",
    placeholder: props.field.placeholder || "",
    helperText: errorText,
    error: errorText === "" ? false : true,
    inputProps: {
      maxLength: props.field.maxLength
    }
  })));
};

var _default = Text;
exports.default = _default;